module.exports = __webpack_public_path__ + "img/parq delux3.7f6016c4.jpg";